import { reviews } from '@/mocks/hoobuyData';

export default function ReviewsSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-3.5 py-1.5 rounded-full bg-accent-100 text-xs font-semibold text-accent-700 mb-4">
            Reviews Reais
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 max-w-xl">
            O que dizem os compradores brasileiros
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className={`w-10 h-10 flex items-center justify-center rounded-full ${review.avatarBg} text-sm font-bold text-foreground-700`}>
                  {review.avatarText}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {review.name}
                  </p>
                  <p className="text-xs text-foreground-400 whitespace-nowrap">
                    {review.username}
                  </p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {review.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}